module.exports = __webpack_public_path__ + "images/chat-icon.9c1ccc7e.png";